export const COOKIE_AGREEMENT_DOC = '/doc/Политика_использования_файлов_cookie.pdf' as const
export const PRIVACY_POLICY_PERSONAL_DATA_DOC = '/doc/Политика_конфиденциальности_персональных_данных.pdf' as const
export const CONSEST_DATA_PERSONAL_ACCOUNT_DOC =
  '/doc/Согласие_на_обработку_персональных_данных_в_личном_кабинете.pdf' as const
export const CONSEST_DATA_PERSONAL_DOC = '/doc/Согласие_на_обработку_персональных_данных.pdf' as const
